import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import axios from 'axios';
import Cookies from 'js-cookie';
import * as R from 'ramda';
import { AXIOS_ERROR_CODES } from 'src/constants/error'; // for cn environment, use the REST API origin from environment variables directly and not the proxy by next.js

var DEFAULT_API_ORIGIN = process.env.NEXT_PUBLIC_ENVIRONMENT === 'china' ? process.env.NEXT_PUBLIC_REST_API_ORIGIN : '/cofit';
export var BASE_URL_API_V4_1 = "".concat(DEFAULT_API_ORIGIN, "/api/v4.1/");
export var BASE_URL_API_V4 = "".concat(DEFAULT_API_ORIGIN, "/api/v4/");
var DEFAULT_AXIOS_CONFIG = {
  baseURL: BASE_URL_API_V4,
  timeout: 30000
};

var onRequestFulfilled = function onRequestFulfilled(config) {
  // insert `access_token` to Authorization header
  var access_token = Cookies.get('access_token');
  var Authorization = config.headers.Authorization || (access_token ? "Bearer ".concat(access_token) : undefined);
  var token = config.headers.token || access_token;
  return _objectSpread(_objectSpread({}, config), {}, {
    headers: _objectSpread(_objectSpread({}, config.headers), {}, {
      Authorization: Authorization,
      token: token
    })
  });
};

var onRequestRejected = function onRequestRejected(error) {
  // Do something with request error
  return Promise.reject(error);
};

var getErrorMessageFromResponse = function getErrorMessageFromResponse(response) {
  var _data$error;

  var data = response === null || response === void 0 ? void 0 : response.data;

  if (!response || !data) {
    return null;
  }

  if (data !== null && data !== void 0 && (_data$error = data.error) !== null && _data$error !== void 0 && _data$error.message && typeof data.error.message === 'string') {
    return data.error.message;
  }

  return typeof data === 'string' ? data : typeof (data === null || data === void 0 ? void 0 : data.message) === 'string' ? data.message : data.message ? JSON.stringify(data === null || data === void 0 ? void 0 : data.message) : data;
};

var onResponseFulfilled = function onResponseFulfilled(response) {
  // Do something with response data
  return response;
};

var onResponseRejected = function onResponseRejected() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // Do something with response error
  var result = _objectSpread({}, error); // Cast axios error code to our error code


  if (R.has(error.code, AXIOS_ERROR_CODES)) {
    result.code = AXIOS_ERROR_CODES[error.code];
  }

  if (result.response) {
    var _result$response, _result$response2, _result$response2$dat;

    // Server responded with error status
    var message = getErrorMessageFromResponse(result.response);
    console.error("Server Error: ".concat(error.response.status, " - ").concat(message));

    if (message) {
      result.message = message;
    }

    result.code = (result === null || result === void 0 ? void 0 : (_result$response = result.response) === null || _result$response === void 0 ? void 0 : _result$response.status) || (result === null || result === void 0 ? void 0 : (_result$response2 = result.response) === null || _result$response2 === void 0 ? void 0 : (_result$response2$dat = _result$response2.data) === null || _result$response2$dat === void 0 ? void 0 : _result$response2$dat.status) || result.code;
  } else {
    console.error('An unexpected error occurred:', result.message);
  }

  return Promise.reject(result);
};

export var DEFAULT_HANDLER = {
  onRequestFulfilled: onRequestFulfilled,
  onRequestRejected: onRequestRejected,
  onResponseFulfilled: onResponseFulfilled,
  onResponseRejected: onResponseRejected
};
export var buildHttpClient = function buildHttpClient(config, handler) {
  var httpClient = axios.create(_objectSpread(_objectSpread({}, DEFAULT_AXIOS_CONFIG), config));

  var axiosHandler = _objectSpread(_objectSpread({}, DEFAULT_HANDLER), handler);

  httpClient.interceptors.request.use(axiosHandler.onRequestFulfilled, axiosHandler.onRequestRejected);
  httpClient.interceptors.response.use(axiosHandler.onResponseFulfilled, axiosHandler.onResponseRejected);
  return httpClient;
};
var httpClient = buildHttpClient();
export default httpClient;